import { atom } from "recoil";

export const onBehalfOfAtom = atom<
	| {
			firstname: string;
			lastname: string;
			phoneNumber: string;
	  }
	| undefined
>({
	key: "onBehalfOf",
	default: undefined,
});
